// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608210844/js/" + chunkId + "." + {"44":"b1c20ab7","225":"58585961","481":"501825e8","486":"4a85412f","770":"35206f74"}[chunkId] + ".0.9937180558765343.chunk.js";
};